import { Component, computed, input } from '@angular/core';
import type { CrmTaskStatus } from '../../models/assigned-task.models';

@Component({
  selector: 'app-crm-task-status-badge',
  standalone: true,
  template: `<span [class]="klass()">{{ label() }}</span>`,
})
export class CrmTaskStatusBadgeComponent {
  readonly status = input.required<CrmTaskStatus>();
  readonly label = input.required<string>();
  readonly size = input<'sm' | 'md'>('md');

  readonly klass = computed(() => {
    const statusClass =
      this.status() === 'IN_PROGRESS'
        ? 'crm-task-badge--status-in-progress'
        : 'crm-task-badge--status-new';
    const sizeClass = this.size() === 'sm' ? 'crm-task-badge--sm' : '';
    return ['crm-task-badge', statusClass, sizeClass].filter(Boolean).join(' ');
  });
}
